import React from 'react';
import { Avatar } from '~/shared/components/Avatar';

export interface PhysicianAvatarProps {
	firstName: string;
	lastName: string;
	fullName: string;
	npiNumber: string;
	physicianLabel?: string;
	children?: React.ReactNode;
}

export function PhysicianAvatar(props: PhysicianAvatarProps) {
	return (
		<div className="flex items-center gap-2.5">
			<Avatar firstName={props.firstName} lastName={props.lastName} />
			<div>
				<p className="font-medium text-gray-900">{props.fullName}</p>
				{props.physicianLabel && <p className="text-xs text-gray-500">{props.physicianLabel}</p>}
				<p className="text-xs text-gray-500">
					NPI {props.npiNumber}
					{props.physicianLabel && <span className="ml-1 italic text-gray-400">&bull;</span>}
					{props.physicianLabel && <span className="ml-1 text-xs italic text-gray-500">Referring</span>}
				</p>
			</div>
			{props.children}
		</div>
	);
}
